import React from "react";
import { Button, Stack } from "@mui/material";
import { borderStyle, checkboxGap, smallGap } from "../../../styles/consts";
import { FullStack, GreyOnHoverStack } from "../../styles/Box.styles";
import { HeadingText } from "../../styles/Text.styles";
import { BiggerIcon } from "../fundamentals/Icon";

export default function CustomPopUp({
  isPopUpOpen,
  content,
  setPopUpOpen,
  heading,
  button1 = "Cancel",
  button2,
  action,
}: {
  isPopUpOpen: boolean;
  content: React.ReactNode;
  setPopUpOpen: (value: boolean) => void;
  heading: string;
  button1?: string;
  button2: string;
  action: () => void;
}) {
  const handleClose = () => {
    setPopUpOpen(false);
  };

  const handleActionAndClose = () => {
    action();
    handleClose();
  };

  const popUpBackgroundClass = "popUpBackground";

  return (
    <FullStack
      sx={{
        position: "fixed",
        top: "0",
        left: "0",
        zIndex: "9999",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        justifyContent: "center",
        alignItems: "center",
        cursor: "crosshair",
        display: isPopUpOpen ? "flex" : "none",
      }}
      className={popUpBackgroundClass}
      onClick={(e: any) => {
        if (e.target.classList.contains(popUpBackgroundClass)) {
          handleClose();
        }
      }}
    >
      <Stack
        sx={{
          minWidth: "35%",
          maxWidth: "40%",
          minHeight: "25%",
          backgroundColor: "white",
          zIndex: "99999",
          cursor: "default",
          border: borderStyle,
        }}
      >
        <Stack
          sx={{
            paddingLeft: checkboxGap,
            borderBottom: borderStyle,
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <HeadingText
            sx={{
              cursor: "text",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {heading}
          </HeadingText>
          <GreyOnHoverStack>
            <BiggerIcon
              sx={{
                height: "3rem",
                width: "3rem",
              }}
              name="BigXMark"
              onClick={handleClose}
            />
          </GreyOnHoverStack>
        </Stack>
        <Stack
          sx={{
            justifyContent: "space-between",
            width: "100%",
            height: "100%",
          }}
        >
          <Stack sx={{ padding: smallGap }}>{content}</Stack>
          <Stack sx={{ flexDirection: "row", width: "100%" }}>
            <Button
              variant="outlined"
              onClick={handleClose}
              sx={{
                "&&": {
                  width: "50%",
                  borderLeft: "none",
                  borderBottom: "none",
                },
              }}
            >
              {button1}
            </Button>
            <Button
              variant="orange"
              onClick={handleActionAndClose}
              sx={{ width: "50%", borderTop: borderStyle }}
            >
              {button2}
            </Button>
          </Stack>
        </Stack>
      </Stack>
    </FullStack>
  );
}
